import React, { Component } from "react"
import Loading from "../components/Loading"

class ApolloQueryHandler extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    if (this.props.loading) return <Loading />

    if (this.props.error) throw new Error(this.props.error)

    let { children, ...props } = this.props

    return children({ ...props })
  }
}

export default ApolloQueryHandler
